import { useCallback } from 'react';

import { useLoginBySessionToken } from '@interlayer/js/hooks/auth/hooks/useLoginBySessionToken';

import { useUpdateRetailUpgradeData } from './useUpdateRetailUpgradeData';

export const useContinueRetailLightLogin = () => {
    const loginBySessionToken = useLoginBySessionToken();
    const updateRetailUpgradeData = useUpdateRetailUpgradeData();

    return useCallback(({ userName, sessionToken }: { userName: string; sessionToken: string }) => {
        return loginBySessionToken(userName, sessionToken)
            .then(updateRetailUpgradeData);
    }, [loginBySessionToken, updateRetailUpgradeData]);
};
